module.exports = __webpack_public_path__ + "static/m3-monitor-1fb8484a7994d90a0e3a905ac7b0694f.png";